import { AssetSource } from '@ve-pro/enums/asset'
export interface FontItem {
  id?: number
  name: string
  file_url: string
  postscript_name?: string
  thumb_url?: string
  value?: string
  label?: string
  svg?: string
  url?: string
  source?: AssetSource
}

export interface FontGroup {
  id: number
  name: string
  type: number
  assets?: FontItem[]
}

export interface LayerConfig {
  prop: string
  field: {
    options: FontItem[]
    clearable: boolean
  }
}

export type FormValue = Record<string, any>

export enum ListType {
  'ALL' = 1,
  'SEARCH' = 2,
}

export interface LangConfig {
  title: string
  switchLoadText: string
  system: string
  forbidden: string
  filter: {
    applyLabel: string
    clearLabel: string
    searchPlaceholder: string
  }
  currentFont: string
  systemFont: string
  result: string
  all: string
  return: string
}

export interface OffsetConfig {
  top?: number | string
  left?: number | string
  right?: number | string
  bottom?: number | string
  height?: number | string
}

export interface AssetFontConfig {
  list?: boolean
}

export type CustomUpdateDialog = (
  dialog: HTMLElement,
  config: OffsetConfig,
) => void
